import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getTopRanking, getMyRanking } from '../utils/firestoreApi';
import { GAME_STATES } from '../config/gameConfig';

const RankingContainer = styled.div`
  width: 100%;
  max-width: 600px;
  color: white;
  min-height: calc(100vh - 250px);
  /* overflow-y: auto; */
  display: flex;
  flex-direction: column;
  background: transparent;
  align-items: center;
`;

const RankingTitle = styled.h1`
  text-align: center;
  font-size: 1.5rem;
  color: white;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
`;

// 탭 컨테이너 스타일
const TabContainer = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 5px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

const Tab = styled.button`
  flex: 1;
  padding: 12px 16px;
  border: none;
  border-radius: 10px;
  background: ${props => props.$active ? 'rgba(255, 255, 255, 0.2)' : 'transparent'};
  color: white;
  font-weight: ${props => props.$active ? 'bold' : 'normal'};
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
  
  ${props => props.$active && `
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  `}

  @media (max-width: 768px) {
    padding: 5px 5px;
  }
`;

const RankingTable = styled.div`
  background: rgba(255, 255, 255, 0.1); /* 반투명 배경은 유지 */
  border-radius: 15px;
  padding: 20px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  flex: 1;
  min-height: 400px; /* 최소 높이 유지 */
  max-height: calc(100vh - 350px); /* 하단 버튼+상단 여백만큼 빼기, 필요시 값 조정 */
  overflow-y: auto;
  width: 100%;
  max-width: 600px;
  position: relative; /* 내부 고정 요소를 위한 상대 위치 */
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  // align-items: center;
  
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
  
  @media (max-width: 768px) {
    min-height: 250px;
    max-height: 450px;
    padding: 6px 2px;
    font-size: 0.85rem;
    max-width: 95%;
  }
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: ${props => props.$gameType === GAME_STATES.WORLDCUP_GAME ? '0.5fr 1.8fr 1.5fr' : '0.5fr 1.8fr 1.5fr 1.5fr'};
  gap: 10px;
  padding: 15px 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 0.9rem;
  
  > div {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  > div:first-child {
    min-width: 50px;
  }
  
  > div:nth-child(4) {
    display: ${props => props.$gameType === GAME_STATES.WORLDCUP_GAME ? 'none' : 'flex'};
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: ${props => props.$gameType === GAME_STATES.WORLDCUP_GAME ? '0.5fr 1.8fr 1.5fr' : '0.5fr 1.8fr 1.5fr 1.5fr'};
  gap: 10px;
  padding: 12px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  align-items: center;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
  
  > div:nth-child(4) {
    display: ${props => props.$gameType === GAME_STATES.WORLDCUP_GAME ? 'none' : 'block'};
  }
`;

const Rank = styled.div`
  font-weight: bold;
  text-align: center;
  font-size: 1.1rem;
  min-width: 50px;
  
  ${props => props.$top3 && `
    color: ${props.$rank === 1 ? '#FFD700' : props.$rank === 2 ? '#C0C0C0' : '#CD7F32'};
    font-size: 1.3rem;
  `}
`;

const Email = styled.div`
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Score = styled.div`
  text-align: center;
  font-weight: bold;
  color: #FFD700;
`;

const Combo = styled.div`
  text-align: center;
  font-weight: bold;
  color:rgb(255, 255, 255);
`;

// 본인 랭킹 스타일 컴포넌트
const UserRankingRow = styled.div`
  position: sticky;
  bottom: 0;
  background: rgb(61, 61, 61);
  border: 2px solid #FFD700;
  border-radius: 10px;
  margin-top: 10px;
  padding: 12px 10px;
  display: grid;
  grid-template-columns: ${props => props.$gameType === GAME_STATES.WORLDCUP_GAME ? '0.5fr 1.5fr 1.2fr' : '0.5fr 1.5fr 1.2fr 1.5fr'};
  gap: 10px;
  align-items: center;
  z-index: 10;
  min-height: 30px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  
  > div:nth-child(4) {
    display: ${props => props.$gameType === GAME_STATES.WORLDCUP_GAME ? 'none' : 'block'};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
  flex-shrink: 0;
`;

const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  
  ${props => props.$primary ? `
    background: var(--primary-gradient);
    color: white;
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
    }
  ` : `
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
    }
  `}
`;

// 목업 데이터 (개발/로컬 테스트용)
/*
const mockRankingData = [
  {
    id: 1,
    nickname: "player1",
    score: 9850,
    combo: 156
  },
  {
    id: 2,
    nickname: "rhythm_master",
    score: 9720,
    combo: 142
  },
  {
    id: 3,
    nickname: "purple_kiss_fan",
    score: 9580,
    combo: 138
  },
  {
    id: 4,
    nickname: "gamer123",
    score: 9450,
    combo: 125
  },
  {
    id: 5,
    nickname: "music_lover",
    score: 9320,
    combo: 118
  },
  {
    id: 6,
    nickname: "rhythm_pro",
    score: 9180,
    combo: 112
  },
  {
    id: 7,
    nickname: "purple_fan",
    score: 9050,
    combo: 108
  },
  {
    id: 8,
    nickname: "game_master",
    score: 8920,
    combo: 95
  },
  {
    id: 9,
    nickname: "music_enthusiast",
    score: 8780,
    combo: 89
  },
  {
    id: 10,
    nickname: "rhythm_champion",
    score: 8650,
    combo: 82
  }
];
*/

function Ranking({ onBack, onRetry, userInfo, gameType }) {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userRanking, setUserRanking] = useState(null); // 본인 랭킹 정보
  const [activeTab, setActiveTab] = useState(gameType || GAME_STATES.PUZZLE_GAME); // 현재 활성 탭

  // 탭 목록 정의
  const tabs = [
    { id: GAME_STATES.PUZZLE_GAME, label: '🧩 퍼즐', icon: '🧩' },
    { id: GAME_STATES.WORLDCUP_GAME, label: '🏆 월드컵', icon: '🏆' },
    { id: GAME_STATES.DINO_GAME, label: '🛹 파씨런', icon: '🛹' },
    { id: GAME_STATES.RHYTHM_GAME, label: '🎵 리듬', icon: '🎵' },
  ];

  // 초기 로딩 시 gameType 설정
  useEffect(() => {
    const initialGameType = gameType === GAME_STATES.RANKING ? GAME_STATES.PUZZLE_GAME : gameType;
    setActiveTab(initialGameType);
  }, [gameType]);

  // activeTab 변경 시 데이터 로드
  useEffect(() => {
    if (activeTab) {
      loadRankingData(activeTab);
    }
  }, [activeTab, userInfo]);

  const loadRankingData = (gameType) => {
    setLoading(true);
    
    // TOP 20 랭킹과 본인 랭킹을 동시에 로드
    Promise.all([
      getTopRanking(gameType),
      userInfo && userInfo.phone ? getMyRanking(gameType, btoa(userInfo.phone)) : Promise.resolve(null)
    ])
      .then(([topData, myRankingData]) => {
        setRanking(topData);
        
        // 본인 랭킹 설정
        if (myRankingData && myRankingData.myRank) {
          if (gameType === GAME_STATES.WORLDCUP_GAME) {
            // 월드컵 게임: around 데이터에서 본인 정보 찾기
            const myData = myRankingData.around.find(item => item.phone === userInfo.phone);
            if (myData) {
              setUserRanking({
                ...myData,
                rank: myRankingData.myRank
              });
            }
          } else {
            // 다른 게임들: 서버에서 바로 myData 사용
            if (myRankingData.myData) {
              setUserRanking({
                ...myRankingData.myData,
                rank: myRankingData.myRank
              });
            }
          }
        } else {
          setUserRanking(null);
        }
        
        setLoading(false);
      })
      .catch(err => {
        console.error('랭킹 데이터 로드 실패:', err);
        setError('랭킹 데이터를 불러오지 못했습니다.');
        setRanking([]); // 에러 시 랭킹 데이터 초기화
        setUserRanking(null); // 사용자 랭킹도 초기화
        setLoading(false);
      });
  };

  // 게임 타입별 제목과 헤더 설정
  const getGameTitle = () => {
    switch (activeTab) {
      case GAME_STATES.RHYTHM_GAME: return '🏆 리듬게임 랭킹';
      case GAME_STATES.PUZZLE_GAME: return '🧩 퍼즐게임 랭킹';
      case GAME_STATES.DINO_GAME: return '🛹 파씨런 랭킹';
      case GAME_STATES.WORLDCUP_GAME: return '🏆 월드컵 랭킹';
      default: return '🏆 랭킹';
    }
  };

  const getHeaderLabels = () => {
    switch (activeTab) {
      case GAME_STATES.RHYTHM_GAME: return ['순위', '닉네임', '점수', '콤보'];
      case GAME_STATES.PUZZLE_GAME: return ['순위', '닉네임', '이동횟수', '소요시간'];
      case GAME_STATES.DINO_GAME: return ['순위', '닉네임', '점수', '소요시간'];
      case GAME_STATES.WORLDCUP_GAME: return ['순위', '영상 제목', '영상 선택자 수'];
      default: return ['순위', '닉네임', '점수', '콤보'];
    }
  };

  const getPlayerData = (player) => {
    switch (activeTab) {
      case GAME_STATES.RHYTHM_GAME:
        return {
          value1: player.score?.toLocaleString?.() ?? '-',
          value2: player.maxCombo ?? '-'
        };
      case GAME_STATES.PUZZLE_GAME:
        return {
          value1: player.moves ?? '-',
          value2: player.timeSpent ?? '-'
        };
      case GAME_STATES.DINO_GAME:
        return {
          value1: player.score?.toLocaleString?.() ?? '-',
          value2: player.timeSpent ?? '-'
        };
      case GAME_STATES.WORLDCUP_GAME:
        return {
          value1: player.title ?? '-',
          value2: player.winnerCount ?? '-'
        };
      default:
        return {
          value1: player.score?.toLocaleString?.() ?? '-',
          value2: player.maxCombo ?? '-'
        };
    }
  };

  const handleTabChange = (gameType) => {
    setActiveTab(gameType);
    setError(null); // 탭 변경 시 에러 초기화
  };

  const headerLabels = getHeaderLabels();

  return (
    <RankingContainer>
      {/* <RankingTitle>{getGameTitle()}</RankingTitle> */}
      
      {/* 탭 네비게이션 */}
      <TabContainer>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            $active={activeTab === tab.id}
            onClick={() => handleTabChange(tab.id)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabContainer>
      
      <RankingTable style={{ display: 'flex', flexDirection: 'column' }}>
        <TableHeader $gameType={activeTab}>
          <div>{headerLabels[0]}</div>
          <div>{headerLabels[1]}</div>
          <div>{headerLabels[2]}</div>
          {activeTab !== GAME_STATES.WORLDCUP_GAME && <div>{headerLabels[3]}</div>}
        </TableHeader>
        
        {/* {loading && <div style={{textAlign: 'center', padding: '20px'}}>불러오는 중...</div>} */}
        {error && <div style={{color: 'red', textAlign: 'center'}}>{error}</div>}
        
        {!loading && !error && (
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            {/* 상위 랭킹 영역 (스크롤 가능) */}
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {ranking.slice(0, 20).map((player, index) => {
                const playerData = getPlayerData(player);
                return (
                  <TableRow key={`${player.nickname || 'unknown'}-${player.phone || 'unknown'}-${index}`} $gameType={activeTab}>
                    <Rank $top3={index < 3} $rank={index + 1}>
                      {index + 1}
                    </Rank>
                    <Email title={activeTab === GAME_STATES.WORLDCUP_GAME ? player.title : player.nickname}>
                      {activeTab === GAME_STATES.WORLDCUP_GAME ? (player.title || '-') : (player.nickname || '-')}
                    </Email>
                    <Score>{activeTab === GAME_STATES.WORLDCUP_GAME ? player.winnerCount : playerData.value1}</Score>
                    {activeTab !== GAME_STATES.WORLDCUP_GAME && 
                    <Combo>
                      {playerData.value2}
                    </Combo>
                    }
                  </TableRow>
                );
              })}
            </div>
            
            {/* 현재 사용자 랭킹 (하단 고정) */}
            {userRanking && (
              <UserRankingRow $gameType={activeTab}>
                <Rank $top3={userRanking.rank <= 3} $rank={userRanking.rank}>
                  {userRanking.rank}
                </Rank>
                <Email title={activeTab === GAME_STATES.WORLDCUP_GAME ? userRanking.title : userRanking.nickname}>
                  {activeTab === GAME_STATES.WORLDCUP_GAME ? (userRanking.title || '-') : (userRanking.nickname || '-')}
                </Email>
                <Score>{activeTab === GAME_STATES.WORLDCUP_GAME ? userRanking.winnerCount : getPlayerData(userRanking).value1}</Score>
                {activeTab !== GAME_STATES.WORLDCUP_GAME && <Combo>{getPlayerData(userRanking).value2}</Combo>}
              </UserRankingRow>
            )}
          </div>
        )}
      </RankingTable>
      
      <ButtonContainer>
        <Button onClick={() => onRetry(activeTab)}>다시하기</Button>
        <Button $primary onClick={onBack}>돌아가기</Button>
      </ButtonContainer>
    </RankingContainer>
  );
}

export default Ranking; 